import { isIFrame } from 'Utils/url';

export const isSalesforceApp = (searchParams: URLSearchParams): boolean =>
  isIFrame() &&
  typeof searchParams.get('sessionId') === 'string' &&
  typeof searchParams.get('userId') === 'string' &&
  typeof searchParams.get('orgId') === 'string' &&
  typeof searchParams.get('accountId') === 'string';

export const isSalesforceApp2 = (searchParams: URLSearchParams): boolean =>
  isIFrame() &&
  typeof searchParams.get('app') === 'string' &&
  searchParams.get('app') === 'salesforce' &&
  (typeof searchParams.get('customerId') === 'string' || typeof searchParams.get('error') === 'string');
